import React from 'react';
import { __ } from '@wordpress/i18n';

// store
import { useStoreValue } from '../../store';

// components
import DomandeTablePreInstructorAsync from '../DashboardPreInstructor/components/DomandeTablePreInstructorAsync';

const DomandePreInstructor = () => {
    const userData = useStoreValue('userData');

    return(
        <div className="appPage">
            <div className="appPage__pageHeader">
                <h1>{__('Domande da valutare', 'gepafin')}</h1>
            </div>

            <div className="appPage__spacer"></div>

            <div className="appPageSection">
                <h2>{__('Nuove domande da valutare', 'gepafin')}</h2>
                <DomandeTablePreInstructorAsync statuses={['AWAITING']} userId={userData.id}/>
            </div>
        </div>
    )
}

export default DomandePreInstructor;